<!--  -->
<template>
  <div
    :class="[
      'ai-guide-book-content',
      {
        'guide-book-off': !sidebarSwitch,
        'view-pdf-content': pdfViewFullScreen,
      },
    ]"
  >
    <div :class="['guide-head']">
      <el-button @click="switchMenu(0)" class="menu-btn" v-show="sidebarSwitch">
        <img class="icon-project" :src="iconCreate" />
        <span class="text">项目任务</span>
      </el-button>
      <el-button
        @click="switchMenu(1)"
        class="menu-btn"
        :class="[userRole == 2 && !homeWorkStatus ? 'un-permit' : '']"
        v-show="sidebarSwitch"
      >
        <img class="icon-project" :src="IconMethod" />
        <span class="text">项目解法</span>
      </el-button>
      <el-button
        v-if="userRole !== 2"
        @click="switchMenu(2)"
        class="menu-btn"
        v-show="sidebarSwitch"
      >
        <img class="icon-project" :src="IconProjectQuestion2" />
        <span class="text">项目题面</span>
      </el-button>
      <el-button
        :class="{ 'sibebar-switch-off': !sidebarSwitch }"
        @click="sidebarSwitchHandle"
      >
        <icon-base
          class="icon-sibebar-switch"
          :icon-name="Icons.SidebarSwitch.iconName"
          v-bind="Icons.SidebarSwitch"
        >
          <icon-sibebar-switch />
        </icon-base>
      </el-button>
    </div>
    <div class="guide-content">
      <!-- 项目任务模块组件 -->
      <ai-book-task
        :Train="Train"
        :trainingId="trainingId"
        @getTrainingByTrainingId="getTrainingByTrainingId"
        v-if="guideMenuVal === 0"
        :editorMode="editorMode"
        :sidebarSwitch="sidebarSwitch"
      />
      <!-- 项目解法模块组件 -->
      <ai-book-explantion
        class="project-solution-section"
        :Train.sync="Train"
        :trainingId="trainingId"
        :createBy="createBy"
        :editorMode="editorMode"
        @getTrainingByTrainingId="getTrainingByTrainingId"
        v-if="guideMenuVal === 1"
      />
      <!-- 项目题面模块组件 -->
      <ai-book-question
        class="project-question-section"
        :Train.sync="Train"
        :createBy="createBy"
        :trainingId="trainingId"
        :editorMode="editorMode"
        @getTrainingByTrainingId="getTrainingByTrainingId"
        v-if="guideMenuVal === 2"
      />
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus'
import aiBookTask from '@/components/blocklyEditor/training/aiBookTask.vue'
import aiBookExplantion from '@/components/blocklyEditor/training/aiBookExplantion.vue'
import aiBookQuestion from '@/components/blocklyEditor/training/aiBookQuestion.vue'
import IconSibebarSwitch from '@/components/icons/typography/SidebarSwitch'
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'aiGuideBook',
  //import引入的组件需要注入到对象中才能使用
  components: {
    IconSibebarSwitch,
    aiBookTask,
    aiBookExplantion,
    aiBookQuestion,
  },
  props: {
    // 实训ID
    trainingId: {
      type: String,
      default: null,
    },
    // 创建人ID
    createBy: {
      type: String,
      default: null,
    },
    //编辑器方式
    editorMode: {
      type: String,
      delete: '',
    },
  },
  data() {
    return {
      sidebarSwitch: true,
      guideMenuVal: 0,
      workspaceIsVisible: true,
      Train: {}, // 实训信息
      pdfViewFullScreen: false,
      Icons: {
        SidebarSwitch: {
          iconName: '收起',
          viewBox: '0 0 13 14',
          width: '13',
          height: '14',
        },
      },
      // iconCreate: require("@/assets/images/ai-editor/icon-create.png"),
      iconCreate: require('@/assets/images/ai-editor/icon-project-tasks.png'),
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
      IconMethod: require('@/assets/images/ai-editor/project-method.png'),
      IconProjectQuestion2: require('@/assets/images/ai-editor/project-question2.png'),
    }
  },
  //监控data中的数据变化
  watch: {
    trainingId: {
      handler(val, oldVal) {
        //获取实训信息
        this.getTrainingByTrainingId()
      },
      immediate: true,
    },
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['userRole', 'accountInfo', 'homeWorkStatus']),
  },

  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var self = this
    bus.$on('guideBookResize', () => {
      self.sidebarSwitch = !self.sidebarSwitch
    })
    bus.$on('getTrainingByTrainingId', () => {
      self.getTrainingByTrainingId()
    })
  },
  methods: {
    switchMenu(num) {
      this.guideMenuVal = num
    },
    // 重绘
    sidebarSwitchHandle(val) {
      this.sidebarSwitch =
        val === 'guideBook' ? this.sidebarSwitch : !this.sidebarSwitch
      let switchObj = {
        sidebarSwitch: this.sidebarSwitch,
        type: 'guideBook',
      }
      bus.$emit('onSidebarSwitch', switchObj)
      this.$emit('sidebarSwitchHandle', switchObj)
    },
    // guideBookSwitchHandler(sidebarSwitch) {
    //   this.sidebarSwitch = this.sidebarSwitch;
    //   let switchObj = {
    //     sidebarSwitch:sidebarSwitch,
    //     type: "guideBook"
    //   };
    //   bus.$emit("onSidebarSwitch", switchObj);
    // },

    /**
     *
     *
     * 提交代码、题面处理方法
     * */
    saveFile(type) {
      bus.$emit('aiEditorSaveFile', type)
    },

    /**
   根据实训id查询实训信息 @data  trainingId实训id
   */
    async getTrainingByTrainingId() {
      let res,
        data = {
          trainingId: this.trainingId,
        }
      res = await PROJECTS.getTrainingByTrainingId(data)
      if (res.isSuccess) {
        this.Train = res.data
        this.$store.state.blocklyHome.Train = res.data
      }
    },
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  destroyed() {
    bus.$off('guideBookResize')
    bus.$off('getTrainingByTrainingId')
  },
  activated() {},
}
</script>
<style lang="scss" scoped>
$bg_area_right: rgba(94, 147, 255, 0.1);
$bg_tool_button: rgba(103, 140, 255, 0.15);
.ai-guide-book-content {
  position: absolute;
  right: 0;
  // top: 140px;
  top: 0;
  // z-index: 30;
  // width: 490px;
  width: 400px;
  height: 100%;
  background-color: $bg_area_right;
  transition: all linear 0.2s;
  border-left: 2px solid rgba(74, 224, 226, 0.1);
  &.guide-book-off {
    width: 0;
  }
  &.view-pdf-content {
    width: 100%;
    z-index: 100;
  }
  .guide-head {
    display: flex;
    justify-content: flex-end;
    height: 50px;
    .menu-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      & > span {
        display: flex;
        align-items: center;
        justify-content: center;
        // margin-right: 20px;
        .text {
          margin-left: 15px;
        }
      }
    }
    & > button {
      width: 178px;
      padding: 12px 0;
      border: 1px solid transparent;
      border-image-slice: 2;
      border-radius: 0;
      margin-right: 2px;
      background-color: $bg_tool_button;
      color: $font_color_1st;
      font-size: $font_size;
      text-align: center;
      vertical-align: middle;
      box-sizing: border-box;

      & + button {
        margin-left: 0;
      }

      &:hover,
      &:focus {
        background-color: transparent;
        opacity: 0.85;
      }

      &:last-child {
        width: 40px;
        margin: 0;
        // &::v-deep .cls-1 {
        //   // fill: $font_color_2nd;
        // }
      }

      .icon-code-run,
      .icon-code-clear {
        margin-right: 0.8em;
      }

      &.sibebar-switch-off {
        position: absolute;
        left: -40px;
        top: 5px;
        z-index: 99;
        .icon-sibebar-switch {
          transform: rotateY(180deg);
        }
      }
    }
  }
}
.un-permit {
  pointer-events: none;
  opacity: 0.3;
}
</style>
